import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

i18n.use(Backend)
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		fallbackLng: 'en',
		supportedLngs: ['en', 'sv'],
		debug: false,
		react: {
			useSuspense: false,
			bindI18n: 'languageChanged loaded',
			bindI18nStore: 'added removed',
		},
		backend: {
			loadPath: '/translations/{{lng}}.json',
		},
		interpolation: {
			escapeValue: false,
		},
	});

i18n.on('languageChanged', (lng) => {
	document.documentElement.lang = lng;
});

export default i18n;
